import { storage } from "./firebase";
// User API

export async function deleteMediaFromStorage(url, callback, error) {
  // Create a reference to the file to delete
  var desertRef = storage.refFromURL(url);
  // Delete the file
  desertRef
    .delete()
    .then(function () {
      if (callback) callback();
    })
    .catch(function (err) {
      if (error) error();
    });
}

export async function deleteMediaArrayFromStorage(array_of_urls, callback) {
  if (array_of_urls) {
    Promise.all(
      array_of_urls.map(async (item) => {
        return await storage.refFromURL(item).delete();
      })
    )
      .then(() => {
        callback();
      })
      .catch(() => {
        callback();
      });
  } else {
    callback();
  }
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export async function uploadMedia(file, content, storageUrl, progressCallback, callback, error) {
  var reader = new FileReader();
  let _file_name;
  switch (file.type) {
    case "video/mp4":
      _file_name = file.name.split(".")[0] + "-" + S4() + ".mp4";
      break;
    case "video/quicktime":
      _file_name = file.name.split(".")[0] + "-" + S4() + ".mov";
      break;
    case "image/png":
      _file_name = file.name.split(".")[0] + "-" + S4() +  ".png";
      // _file_name = "thumbnail.png";
      break;
    case "image/jpeg":
      _file_name = file.name.split(".")[0] + "-" + S4() + ".jpg";
      break;
    case "application/pdf":
      _file_name = file.name.split(".")[0] + "-" + S4() + ".pdf";
      break;
    case "application/zip":
      _file_name = file.name.split(".")[0] + "-" + S4() + ".zip";
      break;
  }

  reader.onloadend = function (evt) {
    var blob = new Blob([evt.target.result], { type: file.type });
    var storageRef = storage.ref(storageUrl + _file_name);
    var uploadTask = storageRef.put(blob);
    uploadTask.on(
      "state_changed",
      function (snapshot) {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (progressCallback) progressCallback(progress);
      },
      function (err) {
        if (error) error(err);
      },
      function () {
        uploadTask.snapshot.ref
          .getDownloadURL()
          .then(function (downloadURL) {
            callback(downloadURL, _file_name);
          })
          .catch((err) => {console.log(err)});
      }
    );
  };

  reader.onerror = function (e) {};
  reader.readAsArrayBuffer(file);
}


export async function uploadMediaImg(file, content, storageUrl, progressCallback, callback, error) {
  var reader = new FileReader();

  reader.onloadend = function (evt) {
    var blob = new Blob([evt.target.result], { type: "image/png" });
    var storageRef = storage.ref(storageUrl + ".png");
    var uploadTask = storageRef.put(blob);
    uploadTask.on(
      "state_changed",
      function (snapshot) {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (progressCallback) progressCallback(progress);
      },
      function (err) {
        if (error) error(err);
      },
      function () {
        uploadTask.snapshot.ref
          .getDownloadURL()
          .then(function (downloadURL) {
            callback(downloadURL);
          })
          .catch((err) => {});
      }
    );
  };

  reader.onerror = function (e) {};
  reader.readAsArrayBuffer(file);
}